var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeIngredients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17V16H7H1H0V15V1V0H1H15H16V1V7V8H17H23H24V9V23V24H23H9H8V23V17ZM8 15H1V1H15V8V9H16H23V23H9V16V15H8ZM13.6464 9.64645L9.64645 13.6464L10.3536 14.3536L14.3536 10.3536L13.6464 9.64645ZM11.75 15.25V19.5185C11.75 20.3367 12.4216 21 13.25 21C14.0784 21 14.75 20.3367 14.75 19.5185V12.25L14 13L12.2963 14.7037H14.375V19.5185C14.375 20.1322 13.8713 20.6296 13.25 20.6296C12.6287 20.6296 12.125 20.1322 12.125 19.5185V14.875L11.75 15.25ZM16.5 11H21V11.7407H20.25V19.5185C20.25 20.3367 19.5784 21 18.75 21C17.9216 21 17.25 20.3367 17.25 19.5185V11.7407H16.5V11ZM17.625 16.5H19.875V19.5185C19.875 20.1322 19.3713 20.6296 18.75 20.6296C18.1287 20.6296 17.625 20.1322 17.625 19.5185V16.5ZM7.5 3H3V3.74074H3.75V11.5185C3.75 12.3367 4.42157 13 5.25 13C6.07843 13 6.75 12.3367 6.75 11.5185V3.74074H7.5V3ZM6.375 6.7037H4.125V11.5185C4.125 12.1322 4.62868 12.6296 5.25 12.6296C5.87132 12.6296 6.375 12.1322 6.375 11.5185V6.7037ZM13 3H8.5V3.74074H9.25V11.5185C9.25 11.5918 9.25538 11.6638 9.26578 11.7342L9.625 11.375V8.5H11.875V9.125L12.25 8.75V3.74074H13V3Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeIngredients);
export default __webpack_public_path__ + "static/media/MergeIngredients.d46254c3bb2c42878e192a81bd6faad9.svg";
export { ForwardRef as ReactComponent };